let IS_PROD = true;
const server = IS_PROD
    ? "https://meetmebackend-d7sz.onrender.com"
    : "http://localhost:8000";

export default server;
